import { forwardRef } from "react";
import classNames from "classnames";
import type { TagProps } from "antd";
import { DefaultTag } from "../DefaultTag";
import styles from "./styles.module.scss";

export type Group = "Family" | "Friends" | "Colleagues" | "Business" | "Hobbies" | "Other";

type Props = TagProps & {
  group: Group;
};

export const GroupTag = forwardRef<HTMLSpanElement, Props>(
  ({ className, group, ...props }, ref) => {
    return (
      <DefaultTag
        ref={ref}
        className={classNames(styles.tag, styles[group.toLowerCase()], className)}
        {...props}
      >
        {group}
      </DefaultTag>
    );
  },
);
